// ─── Nav mobile toggle ────────────────────────────────────────────────────────
const toggle = document.querySelector(".site-nav__toggle");
const nav = document.querySelector(".site-nav__list");

if (toggle && nav) {
  toggle.addEventListener("click", () => {
    const expanded = toggle.getAttribute("aria-expanded") === "true";
    toggle.setAttribute("aria-expanded", String(!expanded));
    nav.classList.toggle("is-open");
  });
}

// ─── Accordion ────────────────────────────────────────────────────────────────
document.querySelectorAll(".accordion__trigger").forEach((btn) => {
  btn.addEventListener("click", () => {
    const item = btn.closest(".accordion__item");
    const panel = item.querySelector(".accordion__panel");
    const isOpen = btn.getAttribute("aria-expanded") === "true";

    // Cerrar todos
    document.querySelectorAll(".accordion__item").forEach((el) => {
      el.querySelector(".accordion__trigger").setAttribute(
        "aria-expanded",
        "false",
      );
      el.querySelector(".accordion__panel").style.maxHeight = null;
    });

    // Abrir el actual si estaba cerrado
    if (!isOpen) {
      btn.setAttribute("aria-expanded", "true");
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
});

// ─── Hero Slider ──────────────────────────────────────────────────────────────
(function () {
  const slides = document.querySelectorAll(".hero__slide");
  const dots = document.querySelectorAll(".hero__dot");
  if (!slides.length) return;

  let current = 0;
  let interval = null;

  function goTo(index) {
    slides[current].classList.remove("is-active");
    dots[current]?.classList.remove("is-active");
    current = (index + slides.length) % slides.length;
    slides[current].classList.add("is-active");
    dots[current]?.classList.add("is-active");
  }

  function next() {
    goTo(current + 1);
  }

  function start() {
    interval = setInterval(next, 5000);
  }

  function stop() {
    clearInterval(interval);
  }

  // Dots
  dots.forEach((dot, i) => {
    dot.addEventListener("click", () => {
      stop();
      goTo(i);
      start();
    });
  });

  // Pausa en hover
  const hero = document.querySelector(".hero");
  hero?.addEventListener("mouseenter", stop);
  hero?.addEventListener("mouseleave", start);

  start();
})();

// ─── Cookies Banner ───────────────────────────────────────────────────────────
(function () {
  const banner = document.getElementById("cookiesBanner");
  const btn = document.getElementById("cookiesAccept");
  if (!banner || !btn) return;

  if (!localStorage.getItem("cookies_accepted")) {
    banner.hidden = false;
    setTimeout(() => banner.classList.add("is-visible"), 100);
  }

  btn.addEventListener("click", () => {
    localStorage.setItem("cookies_accepted", "1");
    banner.classList.remove("is-visible");
    setTimeout(() => (banner.hidden = true), 300);
  });
})();
